import { ArchiveIcon } from "lucide-react";
import { ConfirmationDialog } from "./confirmation-dialog";

export function EndAndArchiveCampaignDialog({
  campaign,
  updateCampaign,
  onClose,
}: {
  campaign: { name: string; id: string };
  updateCampaign: () => void;
  onClose: () => void;
}) {
  return (
    <ConfirmationDialog
      open={true}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={<>End and archive {campaign.name}?</>}
      description={
        <>
          Ending and archiving{" "}
          <span className="tw:text-primary tw:font-semibold">
            {campaign.name}
          </span>{" "}
          stops it permanently. This can't be undone and the campaign can no
          longer be resumed or paused.
        </>
      }
      confirmIcon={<ArchiveIcon />}
      confirmLabel="End and Archive"
      confirmVariant="destructive"
      contentClassName="tw:max-w-sm"
      onConfirm={() => archiveCampaign(updateCampaign, onClose)}
    />
  );
}

function archiveCampaign(updateCampaign: () => void, onClose: () => void) {
  // Call your API to archive the campaign here
  updateCampaign();
  onClose();
}
